<template>
  <b-modal
    id="invest-from-wallet-modal"
    centered
    ref="invest_from_wallet_modal"
    title="Invest from Wallet"
    @show="loadPackages"
    @hide="resetData"
    scrollable
    hide-footer
  >
    <div class="modal-wrap">
      <b-row class="overflow-hidden">
        <b-col cols="5" class="mb-4">
          <div class="wrapper py-3">
            <small>Total Amount</small>
            <h5 class="mb-0">{{ formatMoney(form.units * packagesAmount[form.packageid]) }}</h5>
          </div>
        </b-col>
        <b-col cols="7" class="mb-4">
          <div class="wrapper p-3 bg-light dash-card">
            <small>Estimated returns</small>
            <h5 class="mb-0">{{ roi }}</h5>
          </div>
        </b-col>
        <b-col cols="12">
          <b-form @submit="submit" @input="formInput">
            <b-form-group
              label="Select package"
              :invalid-feedback="formErrors.packageid"
              :state="fieldState.packageid"
            >
              <content-placeholders :rounded="true" v-if="loading && !errorLoading">
                <content-placeholders-heading />
              </content-placeholders>
              <b-button
                variant="primary"
                @click="loadPackages"
                v-else-if="errorLoading"
              >Network Error, Please Retry</b-button>
              <b-form-select
                v-else
                v-model="form.packageid"
                :options="packages"
                :state="fieldState.packageid"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="Number of Units"
              :invalid-feedback="formErrors.units"
              :state="fieldState.units"
            >
              <b-input-group class="mt-3">
                <b-form-input
                  placeholder="Units"
                  v-model="form.units"
                  :state="fieldState.units"
                  id="unit-number"
                  type="number"
                  step="1"
                  @keydown="validateNoDecimals"
                  @input="validateNoDecimalsOnPaste"
                ></b-form-input>

                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="submit"
                    :disabled="error || submitting || loading"
                    type="submit"
                  >
                    <b-spinner v-show="submitting" small></b-spinner>
                    {{ submitting ? "Investing..." : "Invest" }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="8" lg="7" class="text-center position-absolute" style="top:-120px">
          <div class="wrapper dash-card bg-primary p-2 text-white">
            <h5 class="mb-0">
              <small>&#8358;</small>
              50,000
            </h5>
            <small>Per Unit</small>
          </div>
        </b-col>
        <div
          class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style="top:0;left:0;z-index:10;background-color:rgba(255,255,255,0.7)"
          v-if="submitting"
        >
          <b-spinner label="Small Spinner"></b-spinner>
        </div>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { TransactionService } from "@/services";
import { validateRequired, checkFormErrors } from "@/utils/validators";
import { formatMoney, formatPercent } from "@/utils/helpers";

export default {
  name: "invest-modal",
  data() {
    return {
      form: {
        units: 0,
        packageid: null
      },
      packages: {},
      packagesROI: {},
      packagesAmount: {},
      formErrors: {},
      error: false,
      submitting: false,
      loading: false,
      errorLoading: false
    };
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    },
    roi() {
      if (!this.form.packageid) return formatMoney(0);
      return formatMoney(
        this.form.units * this.packagesAmount[this.form.packageid] +
          this.form.units * this.packagesAmount[this.form.packageid] * this.packagesROI[this.form.packageid]
      );
    }
  },
  methods: {
    formatMoney,
    async loadPackages() {
      this.errorLoading = false;
      this.loading = true;
      try {
        const {
          data: packageList
        } = await TransactionService.getActivePackages();
        this.loading = false;

        // Convert for Options
        const packages = {};
        const packagesROI = {};
        const packagesAmount = {};
        packageList.packages.forEach(ele => {
          if(ele.status==1) {
            packages[ele.id] = `${ele.packagename} - ${
              ele.duration
            } months - ${formatPercent(ele.roi / 100)}`;
            packagesROI[ele.id] = Number(ele.roi) / 100;
            packagesAmount[ele.id] = Number(ele.amount);
          }
        });
        this.packages = packages;
        this.packagesROI = packagesROI;
        this.packagesAmount = packagesAmount;
      } catch (err) {
        this.errorLoading = true;
      }
    },
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {

        this.validateForm();

        const data = await TransactionService.investFromWallet(this.form);

        let message = data.message;
        
        this.$store.dispatch("toast", {
          message
        });

        this.$refs.invest_from_wallet_modal.hide();

        const self = this;
        setTimeout(() => {
          self.$router.replace({ name: "investments" });
        }, 1000 * 2);
      } catch (err) {
        //console.log("THE ERR", err);
        
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      let { errors, valid } = validateRequired(this.form);
      if (!errors.units && this.form.units < 1) {
        errors.units = "Please enter number of units to purchase";
        valid = false;
      }
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    validateNoDecimals(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    validateNoDecimalsOnPaste() {
      this.form.units = this.form.units.replace(/[^0-9]+/g, "");
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style></style>
